import { useEffect } from 'react';
import { useGetPublicSharedLinkDownloadUrlLazyQuery } from '../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsPublicSharedLinkService.hooks';
export const useSharedLinkDownload = () => {
  const [getDownloadUrl, {
    data,
    error
  }] = useGetPublicSharedLinkDownloadUrlLazyQuery();
  useEffect(() => {
    if (data !== null && data !== void 0 && data.downloadUrl) {
      window.location = data.downloadUrl;
    }
    if (error) {
      console.error('CHIRP shared link download error:', error);
    }
  }, [data, error]);
  const downloadSharedLink = (sharedLinkId, accessId) => {
    getDownloadUrl({
      variables: {
        sharedLinkId,
        accessId
      }
    });
  };
  return {
    downloadSharedLink
  };
};